"use client";
"use client";
import { ANIMATION_GLOBAL_OFFSET } from "@/lib/animationConfig";
import { useEffect, useRef, useState } from "react";

export default function AnimatedBlock({ children, className = "", style = {} }) {
	// Référence vers le bloc DOM à observer
	const ref = useRef(null);
	// État pour savoir si le bloc est visible dans le viewport
	const [inView, setInView] = useState(false);

	// Effet qui gère l’observation de la visibilité du bloc
	useEffect(() => {
		// Fonction pour vérifier si le bloc est visible
		const checkVisibility = () => {
			if (!document.body.classList.contains('page-enter') && ref.current) {
				const rect = ref.current.getBoundingClientRect();
				const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
				setInView(isVisible);
			}
		};

		const isInsideHeader = ref.current?.closest("header");
		const margin = isInsideHeader
			? '0%'
			: window.innerWidth < 768
			? '0px 0px -50px 0px'
			: '0px 0px -100px 0px';

		// Observer qui déclenche quand l’élément entre/sort du viewport
		const observer = new IntersectionObserver(
			([entry]) => {
				if (!document.body.classList.contains('page-enter')) {
					setInView(entry.isIntersecting);
				}
			},
			{ threshold: 0, rootMargin: margin }
		);

		// Observer qui surveille le retrait de la classe "page-enter" du body
		const mutation = new MutationObserver(() => {
			if (!document.body.classList.contains('page-enter')) {
				checkVisibility();
			}
		});

		// Lance l’observation de l’élément
		if (ref.current) observer.observe(ref.current);
		// Lance l’observation des changements de classe sur le body
		mutation.observe(document.body, { attributes: true, attributeFilter: ['class'] });

		// Nettoyage des observers au démontage du composant
		return () => {
			observer.disconnect();
			mutation.disconnect();
		};
	}, []);

	// Rendu du composant avec classe "inview" si visible
	return (
		<div
			ref={ref}
			className={`animated-block ${inView ? "inview" : ""} ${className}`}
			style={inView ? { ...style, animationDelay: `${ANIMATION_GLOBAL_OFFSET}s` } : style}
		>
			{children}
		</div>
	);
}